<template>
	<div :class="['merchant_layout', { lnb }]">
		<Header v-if="!menuChange">
			<menu-routes
				:key="$route"
				:items="gnb_items"
				:class="{ menu_area: false }"
			></menu-routes>
		</Header>
		<HeaderM v-else></HeaderM>

		<div class="container">
			<div class="content">
				<div class="store_container">
					<div class="merchant_lnb">
						<div class="store_menu">
							<div>
								<h3 v-if="lnb_title" class="mb_20">{{ $t(lnb_title) }}</h3>
								<ul class="customer_info_menu">
									<li v-for="item in lnb_item" :key="item.name">
										<router-link :to="{ name: item.name }">{{
											$t(item.title)
										}}</router-link>
									</li>
								</ul>
							</div>
							<div class="operating_time">
								<div class="border_bottom mb_15">
									<p>{{ $t('banner2.text1') }}</p>
									<span>10:00 - 19:00<br />{{ $t('banner2.text2') }} </span>
								</div>
								<div class="border_bottom mb_15">
									<p>{{ $t('banner2.text3') }}</p>
									<span
										>{{ $t('banner2.text4') }}<br />
										{{ $t('banner2.text5') }}
									</span>
								</div>
								<div>
									<p>{{ $t('banner2.text6') }}</p>
									<span>10:00 - 19:00<br />{{ $t('banner2.text7') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="merchant_content"><router-view></router-view></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '@/components/Layout/Header';
import HeaderM from '@/components/Layout/Header.m';
import MenuRoutes from '@/components/Menu/Routes.vue';

export default {
	name: 'Layout',
	props: {
		lnb: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			gnb_items: [
				{
					name: 'merchant-console-catalog',
					title: 'menu.merchant-console-catalog',
				},
				{
					name: 'merchant-console-transaction-list',
					title: 'menu.merchant-console-transaction-list',
				},
				{
					name: 'merchant-console-settlement_account',
					title: 'menu.merchant-console-settlement_account',
				},
				{
					name: 'merchant-console-cs-notice',
					title: 'menu.merchant-console-cs-notice',
				},
				// {
				// 	name: 'merchant-console-certification-kyc',
				// 	title: 'menu.merchant-console-certification-kyc',
				// },
				{
					name: 'auth-dashboard',
					title: 'menu.merchant.personal',
				},
			],
			lnb_items: {
				cs: [
					{
						name: 'merchant-console-cs-notice',
						title: 'merchant.menu_2.menu1',
					},
					{
						name: 'merchant-console-cs-inquiry',
						title: 'merchant.menu_2.menu2',
					},
					{
						name: 'merchant-console-cs-inquiry-list',
						title: 'merchant.menu_2.menu3',
					},
					{ name: 'merchant-console-cs-faq', title: 'merchant.menu_2.menu4' },
				],
				// certification: [
				// 	{
				// 		name: 'merchant-console-certification-kyc',
				// 		title: 'merchant.menu_2.menu5',
				// 	},
				// 	{
				// 		name: 'merchant-console-certification-email',
				// 		title: 'merchant.menu_2.menu6',
				// 	},
				// 	{
				// 		name: 'merchant-console-certification-otp',
				// 		title: 'merchant.menu_2.menu7',
				// 	},
				// 	{
				// 		name: 'merchant-console-certification-security',
				// 		title: 'merchant.menu_2.menu9',
				// 	},
				// ],
			},
			lnb_titles: {
				cs: 'menu.merchant-console-cs-notice',
				certification: 'menu.merchant-console-certification-kyc',
			},
			lnb_item: [],
			lnb_title: '',
			menuChange: window.innerWidth < 1200,
		};
	},
	components: {
		Header,
		HeaderM,
		MenuRoutes,
	},
	created() {
		if (this.lnb) {
			if (this.$route.name.includes('cs')) {
				this.lnb_item = this.lnb_items.cs;
				this.lnb_title = this.lnb_titles.cs;
			} else {
				this.lnb_item = this.lnb_items.certification;
				this.lnb_title = this.lnb_titles.certification;
			}
		}
		window.addEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
			this.width = window.innerWidth;
			this.menuChange = this.width < 1200;
		},
	},
};
</script>
<style scoped>
.store_container {
	display: flex;
	width: 100%;
	min-height: 700px;
}
.merchant_layout.lnb .store_container {
	border-radius: 20px;
	background-color: #fff;
	box-shadow: 2px 4px 10px rgb(136 136 136 / 10%);
}
.store_menu {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	width: 250px;
	padding: 20px 0 20px 20px;
	background: #ca0000;
	border-radius: 20px;
	position: relative;
	top: 0;
	left: 0;
}
.store_menu h3 {
	color: #fff;
}
.store_menu ul li a {
	padding: 10px;
	color: #fff;
	display: block;
	position: relative;
	font-size: 14px;
}
.store_menu ul li a::before,
.store_menu ul li a::after {
	content: '';
	position: absolute;
	right: 0;
	width: 20px;
	height: 40px;
}
.store_menu ul li a::before {
	top: -40px;
	border-radius: 0 0 10px 0;
}
.store_menu ul li a::after {
	bottom: -40px;
	border-radius: 0 10px 0 0;
}
.store_menu ul li a.router-link-active {
	color: #ca0000;
	background: #fff;
	border-radius: 10px 0 0 10px;
}
.store_menu ul li a.router-link-active::before {
	box-shadow: 0 20px 0 0 #fff;
}
.store_menu ul li a.router-link-active::after {
	box-shadow: 0 -20px 0 0 #fff;
}
.operating_time {
	width: 210px;
	padding: 20px;
	border-radius: 20px;
	background-color: rgba(0, 0, 0, 0.15);
}
.operating_time p {
	color: #fff;
	margin-bottom: 15px;
	font-weight: bold;
	font-size: 15px;
}
.operating_time span {
	font-size: 13px;
	color: #fff;
	font-weight: 300;
}
.border_bottom {
	border-bottom: 1px solid rgba(255, 255, 255, 0.5);
	padding-bottom: 15px;
}
</style>
